import { Component, OnInit } from '@angular/core';
import { APP_VERSION } from '../../../constants/app-version';
import { AppVersionService } from '../../../services/app-version/app-version.service';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.css'],
    standalone: false
})
export class HelpComponent implements OnInit {

  loadingBar: boolean = true;
  img = 'assets/Logo_MITS_APP.jpg';
  appVersionNow = APP_VERSION;
  appVersionNew = "-";
  displayUpdateButton: boolean = false;

  constructor(
    private appVersionService: AppVersionService,
  ) { }

  ngOnInit(): void {
    this.getAppVersion();
  }

  getAppVersion() {
    this.loadingBar = true;
    this.appVersionNow = this.appVersionService.currentVersion;

    void Promise.all([
      this.appVersionService.fetchDeployedVersionInfo(),
      this.appVersionService.fetchServerVersionAsync(),
    ]).then(([deployedInfo, serverVersion]) => {
      // "Última versión" debe venir de la BD (API), no del version.json servido por el frontend.
      this.appVersionNew = serverVersion || deployedInfo?.version || '-';
      this.displayUpdateButton = this.appVersionService.hasUpdateAvailable(
        deployedInfo?.version ?? null,
        deployedInfo?.buildHash ?? null,
        serverVersion,
      );
      this.loadingBar = false;
    }).catch(() => {
      this.appVersionNew = '-';
      this.loadingBar = false;
    });
  }

  updateApp() {
    this.appVersionService.requestUpdate(this.appVersionNew);
  }

}
